import type { FaireProductEntity } from "../../entity_types/product";

export const p_tt89nbsc6t: FaireProductEntity = {
  token: "p_tt89nbsc6t",
  type: "product",
  name: "Little Card Big Thanks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f82d6c7ee379fbe19b709bb60cfabc9afa4f3dd3628919e48c4991055158440f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d95865cb4fc2017deb5cee818a255b93da3e0499b8d903479a924db19f508752.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:40.165Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
